import { render, staticRenderFns } from "./PersonDocumentKind.vue?vue&type=template&id=aff4b92a&scoped=true&"
import script from "./PersonDocumentKind.vue?vue&type=script&lang=js&"
export * from "./PersonDocumentKind.vue?vue&type=script&lang=js&"
import style0 from "./PersonDocumentKind.vue?vue&type=style&index=0&id=aff4b92a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff4b92a",
  null
  
)

export default component.exports